import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";

import {useOutsideAlerter} from '../../utils/utilElements';

import PlaceBidComponent from './PlaceBidComponent';
import AddFundsComponent from './AddFundsComponent';
import AddFundsToGlipComponent from './AddFundsToGlip';
import WithdrawGlipFundComponent from './WithdrawGlipFundComponent';
import AddSwitchMaticComponent from './AddSwitchMaticComponent';

import {handleSwitchChain, checkIfActiveChain, convertToHex} from '../../utils/chainUtils'
import {CHAIN_ID, CONTRACT_ADDRESS} from '../../constants/project_variables';
import eventBus from '../../utils/globalPubSub';

import CancelIcon from "../../assets/cancel_icon.svg";

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;

const Title = styled.div`
    font-size: 24px;
`;

const Subtitle = styled.a`
    font-size: 12px;
    padding: 8px 12px;
    background: #000;
    margin-top: 12px;
    border-radius: 4px;

`;

export default function WinBidModal(props) {
    
    const [isOpen, setIsOpen] = useState(false);
    const [address, setAddress] = useState();

    useEffect(() => {
        eventBus.on("auction-won", (userDetails) => {
            setIsOpen(true)
	    setAddress(userDetails.userName);
        });
        return ()=>{eventBus.remove("auction-won");}
    },[])


    let modalWidth = "446px";
    let modalHeight = "330px"

    const handleModalCloseEvent = ()=>{
        setIsOpen(false);
    }

    
    return (
	<Modal
	    isOpen={isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
		}
	    }}
	>
	    <div
		 style={{marginLeft:24, marginTop:30,
			 marginRight:24, marginBottom:30,
			 position: "relative"
		 }}>
		<img onClick={()=>{handleModalCloseEvent()}}  src={CancelIcon}
		     style={{
			 position: "absolute", opacity: 0.4,
			 height: 14, width:14,
			 right:10, cursor:"pointer"
		     }}
		/>
            <div style={{height: 250, flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Title>Congrats you WON the NFT!</Title>
                <div style={{display: 'flex'}}>
                    <Subtitle target="_blank" href={`${domain}/address/${address}`}>View your Profile</Subtitle>
                    <Subtitle style={{marginLeft: 8}} target="_blank" href='https://discord.gg/zfHEZ3hgwT'>Join Discord for support</Subtitle>
                </div>
            </div>
	    </div>
	</Modal>
    );
}

